// An external link beside a fold header's title. A link cannot sit inside the header's button, so
// it is laid over the same grid cell, after an invisible copy of the title that gives it its place.

import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';

export function HeaderLink({ title, href, label, titleClassName }: { title: string; href: string; label: string; titleClassName: string }) {
  return (
    <div className="pointer-events-none flex min-w-0 items-start gap-1 pr-[26px] [grid-area:1/1]">
      <span aria-hidden className={cn('invisible line-clamp-2 break-words', titleClassName)}>
        {title}
      </span>
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        aria-label={label}
        title={label}
        className="pointer-events-auto flex size-4 shrink-0 items-center justify-center text-gray-700 hover:text-text-body"
      >
        <ExternalLink className="size-3.5" />
      </a>
    </div>
  );
}
